import { render, staticRenderFns } from "./BonSettings.vue?vue&type=template&id=bac63d06&"
import script from "./BonSettings.vue?vue&type=script&lang=js&"
export * from "./BonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports